import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import React from 'react';
import { H6Emphasized, YStack } from 'smoothie';

import type { DbosDurationStatItem } from '../types/DbosTypes';
import { formatDurationMs } from './dbosConstants';

interface DbosDurationStatsProps {
    stats: DbosDurationStatItem[];
}

const durationBodyTemplate = (value: number | null) => (
    <span style={{ fontFamily: 'monospace', fontSize: '0.8rem' }}>
        {formatDurationMs(value)}
    </span>
);

export const DbosDurationStats = ({ stats }: DbosDurationStatsProps) => {
    return (
        <YStack gap={8} width="100%">
            <H6Emphasized>Workflow Performance</H6Emphasized>
            <DataTable
                value={stats}
                size="small"
                tableStyle={{ width: '100%', fontSize: '0.875rem' }}
                emptyMessage="No duration data available"
                sortField="avgDurationMs"
                sortOrder={-1}
            >
                <Column
                    field="workflowName"
                    header="Workflow"
                    style={{ fontSize: '0.75rem' }}
                    sortable
                />
                <Column
                    field="configName"
                    header="Config"
                    style={{ fontSize: '0.75rem' }}
                />
                <Column
                    field="count"
                    header="Count"
                    alignHeader="right"
                    bodyStyle={{ textAlign: 'right' }}
                    sortable
                />
                <Column
                    header="Avg"
                    alignHeader="right"
                    bodyStyle={{ textAlign: 'right' }}
                    sortable
                    sortField="avgDurationMs"
                    body={(row: DbosDurationStatItem) =>
                        durationBodyTemplate(row.avgDurationMs)
                    }
                />
                <Column
                    header="Min"
                    alignHeader="right"
                    bodyStyle={{ textAlign: 'right' }}
                    body={(row: DbosDurationStatItem) =>
                        durationBodyTemplate(row.minDurationMs)
                    }
                />
                <Column
                    header="Max"
                    alignHeader="right"
                    bodyStyle={{ textAlign: 'right' }}
                    body={(row: DbosDurationStatItem) =>
                        durationBodyTemplate(row.maxDurationMs)
                    }
                />
                <Column
                    header="p50"
                    alignHeader="right"
                    bodyStyle={{ textAlign: 'right' }}
                    body={(row: DbosDurationStatItem) =>
                        durationBodyTemplate(row.p50DurationMs)
                    }
                />
                <Column
                    header="p95"
                    alignHeader="right"
                    bodyStyle={{ textAlign: 'right' }}
                    sortable
                    sortField="p95DurationMs"
                    body={(row: DbosDurationStatItem) =>
                        durationBodyTemplate(row.p95DurationMs)
                    }
                />
                <Column
                    header="Queue Wait"
                    alignHeader="right"
                    bodyStyle={{ textAlign: 'right' }}
                    body={(row: DbosDurationStatItem) =>
                        durationBodyTemplate(row.avgQueueWaitMs)
                    }
                />
            </DataTable>
        </YStack>
    );
};
